// 줌 레벨 상수
export const MIN_ZOOM = 25;
export const MAX_ZOOM = 200;
export const ZOOM_STEP = 25;
export const DEFAULT_ZOOM = 100;

// 회전 각도 상수
export type RotationAngle = 0 | 90 | 180 | 270;
export const ROTATION_STEP = 90;
export const DEFAULT_ROTATION: RotationAngle = 0;

// 뷰모드 상수
export const VIEW_MODE = {
  FIT: 'fit' as const,
  FULLSCREEN: 'fullscreen' as const,
};

// 지원 파일 형식
export const SUPPORTED_IMAGE_FORMATS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'svg',
  'webp',
];

export const SUPPORTED_DOCUMENT_FORMATS = [
  'pdf',
  'docx',
  'ppt',
  'xls',
  'csv',
  'md',
  'markdown',
  'txt',
  'htm',
  'html',
];

export const ALL_SUPPORTED_FORMATS = [
  ...SUPPORTED_IMAGE_FORMATS,
  ...SUPPORTED_DOCUMENT_FORMATS,
];

// 파일 형식별 추천 프롬프트 (하드코딩, 추후 서버에서 제공)
export const DEFAULT_PROMPTS_BY_TYPE: Record<string, string> = {
  pdf: '이 문서의 핵심 내용을 요약해주세요.',
  docx: '문서의 주요 논점을 정리해주세요.',
  image: '이 이미지에서 발견된 텍스트를 추출해주세요.',
  ppt: '이 프레젠테이션의 주요 내용을 정리해주세요.',
  xls: '이 스프레드시트의 데이터를 분석해주세요.',
  csv: '이 데이터의 패턴을 분석해주세요.',
  markdown: '이 문서의 핵심 내용을 요약해주세요.',
  text: '이 문서의 핵심 내용을 요약해주세요.',
  html: '이 문서의 핵심 내용을 요약해주세요.',
};
